// Page header with the action buttons. Extracted from
// ProductionSchedulePage so the shell stays under the 150-line cap.
import type { JobDto } from "../../../../../../shared/types/production-schedule";
import { ExportMenu } from "./ExportMenu";

interface Props {
  jobs: JobDto[];
  onNewJob(): void;
  onManageTeam(): void;
  onCutOptimiser(): void;
}

export function ProductionPageHeader({
  jobs,
  onNewJob,
  onManageTeam,
  onCutOptimiser,
}: Props) {
  return (
    <div className="bsp-page-header" style={{ justifyContent: "space-between" }}>
      <h1 className="bsp-page-title">Production Schedule</h1>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button type="button" className="bsp-btn bsp-btn-secondary" onClick={onManageTeam}>
          Settings
        </button>
        <button type="button" className="bsp-btn bsp-btn-secondary" onClick={onCutOptimiser}>
          Cut Optimiser
        </button>
        <ExportMenu jobs={jobs} />
        <button type="button" className="bsp-btn bsp-btn-primary" onClick={onNewJob}>
          + New Job
        </button>
      </div>
    </div>
  );
}
